var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-method", class: { active: _vm.active } },
    [
      _c("div", { staticClass: "header" }, [
        _c("span", { staticClass: "payment-method-name" }, [
          _vm._v(_vm._s(_vm.getName))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "body" }, [
        _c("img", {
          staticClass: "ui image",
          attrs: { src: _vm.paymentMethodImage, alt: _vm.name }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "payment-method-actions" }, [
        !_vm.active
          ? _c(
              "div",
              {
                staticClass: "ui blue circular button",
                class:
                  (_vm.slug === "mobile_pay" &&
                    !_vm.$store.getters.activeMerchant.mobile_pay) ||
                  (_vm.slug === "vipps" &&
                    !_vm.$store.getters.activeMerchant.vipps)
                    ? "disabled"
                    : "",
                on: { click: _vm.selectPaymentMethod }
              },
              [_vm._v(_vm._s(_vm.$t("globals.buttons.select")) + "\n    ")]
            )
          : _c(
              "div",
              {
                staticClass: "ui blue circular button",
                class: { disabled: !_vm.editable },
                on: { click: _vm.deselectPaymentMethod }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("globals.buttons.deselect")) +
                    "\n    "
                )
              ]
            )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d1ab33e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d1ab33e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentMethod.vue
// module id = gUkd
// module chunks = 1